import { CompanyLogo } from '@/components/CompanyLogo'
import { Flex, Text } from '@chakra-ui/react'
import { OfferType } from 'BrokerTsLib/src/dtos'
import { getInsurerName } from 'BrokerTsLib/src/enums'
import { AnimatedProgressBar } from './AnimatedProgressBar'
import { MotionFlex, itemVariants } from './animations'
import type { ChartDataItem } from './types'

interface CompanyRowProps {
  company: ChartDataItem
  percentage: number
  label: string | number
  maxLabelLength: number
  insurers: Array<{ id: number; name: string }>
  textColor: string
  selectedMetric: 'count' | 'totalValue'
}

export const CompanyRow = ({
  company,
  percentage,
  label,
  maxLabelLength,
  insurers,
  textColor,
  selectedMetric
}: CompanyRowProps) => {
  const insurerObject = insurers.find(x => x.id === company.insurerId) || {
    id: company.insurerId,
    name: company.name || getInsurerName(company.insurerId) || 'Neznámá pojišťovna'
  }

  return (
    <MotionFlex
      key={company.name}
      align="center"
      justify="space-between"
      gap={4}
      h='40px'
      variants={itemVariants}
      position={'relative'}
    >
      <CompanyLogo
        insurer={insurerObject}
        offerType={OfferType.Standard}
        width="56px"
        height="40px"
      />
      <Flex align="center" flex={1} gap={3}
        flexGrow={1} justifyContent="space-between">
        <AnimatedProgressBar percentage={percentage} metricKey={selectedMetric} />
        <Text
          fontSize="xs"
          color={textColor}
          fontWeight="medium"
          whiteSpace='nowrap'
          textAlign="right"
          w={`${maxLabelLength}ch`}
          zIndex={1}
        >
          {label}
        </Text>
      </Flex>
    </MotionFlex>
  )
}
